/**
 * Fallback handler: tts-fail
 *
 * Fires when the TTS endpoint returns a server 5xx or fails to deliver
 * its first audio chunk within 1.5s.
 * A retry action is provided so the user can re-attempt TTS playback.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeTtsFailBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "tts-fail",
    message:
      "Text-to-speech is temporarily unavailable. Voice responses are paused.",
    retryAction: onRetry,
    retryLabel: "Retry",
  };
}
